<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <AddVehicle />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import AddVehicle from "./components/AddVehicle";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    AddVehicle,
    // ProjectsTable,
  },
};
</script>
